// extracted by mini-css-extract-plugin
export default {"map":"Menu_map__kyBBo","panel":"Menu_panel__nqmrL","stop":"Menu_stop__ZKATW"};